module.exports = "/images/logo-iluria-2020.png?432d15690799480a9d7a66feec493f01";